import React from 'react';
import classNames from 'classnames/bind';
import { TextInput } from 'components';
import PropTypes from 'prop-types';
import { debounce } from 'utils/common';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

export const PopupInputEmail = ({ value, onChange, placeholder }) => {
  const debouncedChangeHandler = debounce(onChange, 350);

  return (
    <TextInput
      name="PopupEmail"
      className={cx('input-popup-email')}
      value={value}
      onChange={debouncedChangeHandler}
      placeholder={placeholder}
    />
  );
};

PopupInputEmail.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};
